import React, { useState, useEffect } from "react";
import { Typography, Button, Form, Input, Switch } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import Pageloader from "../../../components/loader";
import { DevSDummyPermissionHelper, validationErrors } from "../../../utils/Helpers";
import { useNavigate, useParams } from "react-router-dom";
import * as zoneActions from "../../../redux/actions/zone.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title } = Typography;
const pageLink = "zones";

const ZoneAdd = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { zoneId } = params;
  const [loading, setLoading] = useState(false);
  const [pagename, setpagename] = useState("Add new");

  useEffect(() => {
    if (zoneId){
      setpagename("Edit");
      ForSingleDataEdit(zoneId)
    }
  }, [zoneId])

  const ForSingleDataEdit = async (id) => {
    try {
      setLoading(true);
      await props.zoneActions.singleZoneStoreAction(id);
    } catch (e) {} finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (props.zoneViewdata && props.zoneViewdata.length !== 0 && zoneId){
      formView(props.zoneViewdata)
    }
  }, [props.zoneViewdata, zoneId])

  const formView = (values) => {
    let fixData = {
      ...values,
      "latitude": values?.startPoint?.latitude,
      "longitude": values?.startPoint?.longitude,
      "status": values.isActive && values.isActive ? true : false,
    }
    form.setFieldsValue(fixData);
  }
  const [form] = Form.useForm();


  const onFinish = async (values) => {
    let fixData = {
      ...values,
      "startPoint": {
        "latitude": values.latitude,
        "longitude": values.longitude,
      },
      "isActive": values.isActive === true ? true : false,
    }
    delete fixData["latitude"]
    delete fixData["longitude"]
    // console.log("props.zoneViewdata", values, fixData)
    // return null
    try {
      setLoading(true);
      if (pagename === "Edit"){
        fixData.zoneId = zoneId;
        await props.zoneActions.patchZoneAction(fixData, zoneId).then((res)=>{
          if (res.status === 200 || res.status === 201) {
            navigate(`/${pageLink}`)
          }
        });
      } else {
        await props.zoneActions.postZoneStoreAction(fixData).then((res)=>{
          if (res.status === 200 || res.status === 201) {
            navigate(`/${pageLink}`)
          }
        });
      }
    } catch (e) { 
      // console.log("e", e)
      validationErrors(e) } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{`${pagename} Zone`}</Title>
        <Button onClick={() => navigate(`/${pageLink}`)}><RollbackOutlined /></Button>
      </div>
      <div className="p-content">
        {loading ? <Pageloader /> : <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name={["zoneName"]}
            label={"Zone Name"}
            rules={[{required: true, message: "Please enter Value"}]}
            >
            <Input placeholder="Zone Name"/>
          </Form.Item>
          {zoneId ? "" :
          <Form.Item
            name={["zoneSlug"]}
            label={"Zone Slug"}
            rules={[
              {required: true, message: "Please Select value"},
              {
                pattern: new RegExp(/^[a-z0-9_]+$/i),
                message: "field does not accept space or special characters use underscore"
               }
            ]}
          >
            <Input placeholder="Zone Slug" disabled={zoneId ? true : false} onInput={e => {e.target.value = e.target.value.toLowerCase(); e.target.value = e.target.value.replace(' ', '_')} } />
          </Form.Item>
          }

          <Form.Item
            name={["email"]}
            label={"Zone Email"}
            rules={[{required: true, message: "Please enter Value"}]}
            >
            <Input placeholder="Zone Email"/>
          </Form.Item>
          <Form.Item
            name={["phone"]}
            label={"Zone phone"}
            rules={[{required: true, message: "Please enter Value"}]}
            >
            <Input placeholder="Zone phone"/>
          </Form.Item>
          <Form.Item
            name={["address"]}
            label={"Zone address"}
            rules={[{required: true, message: "Please enter Value"}]}
            >
            <Input placeholder="Zone address"/>
          </Form.Item>
          <Form.Item
            name={["display_address"]}
            label={"Zone display_address"}
            rules={[{required: true, message: "Please enter Value"}]}
            >
            <Input placeholder="Zone display_address"/>
          </Form.Item>
          <Form.Item
            name={["description"]}
            label={"Zone description"}
            rules={[{required: true, message: "Please enter Value"}]}
            >
            <Input placeholder="Zone description"/>
          </Form.Item>

          <Form.Item
            name={["latitude"]}
            label={"Latitude"}
            rules={[{required: true, message: "Please enter Value"}]}
          >
            <Input style={{width: "100%"}} placeholder="eg.123" />
          </Form.Item>
          <Form.Item
            name={["longitude"]}
            label={"Longitude"}
            rules={[{required: true, message: "Please enter Value"}]}
          >
            <Input style={{width: "100%"}} placeholder="eg.123" />
          </Form.Item>
          <Form.Item
            name={["storeId"]}
            label={"Store Id"}
            rules={[{required: true, message: "Please enter Store id"}]}
          >
            <Input disabled={zoneId ? true : ""} style={{width: "100%"}} placeholder="eg.123" />
          </Form.Item>
          <Form.Item name={["isActive"]} label={"Is Active"} valuePropName="checked"><Switch/></Form.Item>
          <Form.Item name={["validate_location"]} label={"100M location validation"} valuePropName="checked"><Switch/></Form.Item>
          <Form.Item name={["has_ship_time"]} label={"Check packed time in cron assignment logic"} valuePropName="checked"><Switch/></Form.Item>
          {
            (DevSDummyPermissionHelper(props?.emailUser?.email)) &&
              <>
                <Form.Item name={["cron_status"]} label={"Cron start/stop"} valuePropName="checked"><Switch/></Form.Item>
                <Form.Item name={["cron_time"]} label={"Cron intervel"} rules={[{message: "Please enter Cron intervel"}]} >
                  <Input style={{width: "100%"}} placeholder="eg. * * * * * *" />
                </Form.Item>
              </>
          }
          <Button className="submit" htmlType="submit">{zoneId && zoneId ? "Update" : "Submit"}</Button>
        </Form>}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    emailUser: state.authReducer.user,
    zoneViewdata: state.ZoneReducer.zoneViewdata,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoneAdd);